// src/hooks/useAuth.js
import { useState, useEffect } from 'react';
import {
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider,
  signOut
} from 'firebase/auth';
import { auth } from '../services/firebase';
import { createUserWithPendingStatus, getUserStatus } from '../services/firestore';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userStatus, setUserStatus] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          const status = await getUserStatus(currentUser.uid);
          setUserStatus(status);
        } catch (err) {
          console.error('Error al obtener status del usuario:', err);
        }
      }
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const loginWithGoogle = async () => {
    try {
      setLoading(true);
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account'
      });
      const result = await signInWithPopup(auth, provider);

      // Crear usuario con status PENDIENTE si no existe
      await createUserWithPendingStatus(result.user.uid, result.user.email);

      setUser(result.user);
      setError(null);
    } catch (err) {
      console.error('Error al iniciar sesión:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
      setUser(null);
    } catch (err) {
      console.error('Error al cerrar sesión:', err);
      setError(err);
    }
  };

  return { user, loading, error, loginWithGoogle, logout, userStatus };
};